import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material'
import { Delete, MoreVert } from '@mui/icons-material'
import { StyledMenu } from '../../styles/PopupStyles'
import MenuItem from '@mui/material/MenuItem'
import { useNotification } from '../../store/redux/hooks'
import { t } from 'i18next'
import { Trans } from 'react-i18next'
import { useDeleteRecruitmentMutation } from '../../store/redux/reducers/recruitmentSlice'
import ConfirmButton from '../Button/ConfirmButton'
import { createErrorMessage } from '../../store/utils'

type RecruitmentActionMenuProps = {
  recruitmentId: string
}

const RecruitmentActionMenu = ({ recruitmentId }: RecruitmentActionMenuProps) => {
  const theme = useTheme()
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false)
  const { displayNotification } = useNotification()
  const [deleteRecruitment] = useDeleteRecruitmentMutation()

  const handleDeleteCandidate = async (popupState: any) => {
    if (recruitmentId === null) {
      return
    }
    try {
      await deleteRecruitment(recruitmentId).unwrap()
      displayNotification({ message: t('page.candidateDetails.alert.recruitmentDeleted'), type: 'success' })
    } catch (error) {
      let errorDescription = createErrorMessage(error)
      displayNotification({
        message: `${t('page.candidateDetails.alert.recruitmentDeleteError')}. ${errorDescription}`,
        type: 'error',
      })
    }
    popupState.close()
    setOpenDeleteDialog(false)
  }

  return (
    <PopupState
      popupId={`recruitment-action-menu-${recruitmentId}`}
      variant={'popover'}
      parentPopupState={null}
      disableAutoFocus={null}
    >
      {popupState => (
        <React.Fragment>
          <IconButton
            disabled={false}
            {...bindTrigger(popupState)}
            sx={{ color: 'inherit' }}
            aria-label={`recruitment-${recruitmentId}-action-menu`}
          >
            <MoreVert />
          </IconButton>
          <StyledMenu sx={{ '& .MuiPaper-root': { minWidth: '50px' } }} {...bindMenu(popupState)}>
            <MenuItem onClick={() => setOpenDeleteDialog(true)}>
              <ListItemIcon>
                <Delete />
              </ListItemIcon>
              <ListItemText>{t('page.vacationView.delete')}</ListItemText>
            </MenuItem>
          </StyledMenu>
          <Dialog
            onClose={() => {
              setOpenDeleteDialog(false)
            }}
            open={openDeleteDialog}
            PaperProps={{
              style: {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(2),
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(2),
              },
            }}
          >
            <DialogTitle>{t('page.candidateDetails.dialog.delete.title')}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Trans i18nKey="page.candidateDetails.dialog.delete.content" />
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ gap: 2 }}>
              <Button size="small" onClick={() => setOpenDeleteDialog(false)}>
                {t('page.candidates.dialog.delete.return')}
              </Button>
              <ConfirmButton
                text={t('page.candidates.dialog.delete.confirm')}
                onClick={() => handleDeleteCandidate(popupState)}
              />
            </DialogActions>
          </Dialog>
        </React.Fragment>
      )}
    </PopupState>
  )
}

export default RecruitmentActionMenu